module.exports = __webpack_public_path__ + "assets/img/one.44547522.png";